export interface ReadingData {
  id: string | number;
  attributes: Attributes;
  relationships: ServiceRelationship[] | null;
  value: number;
  type?: 'meter-reading' | ''
}

export interface Attributes {
  readings: {
    'kw' : ReadingEntry[];
    'mlb' : ReadingEntry[];
    'ccf' : ReadingEntry[];
    'therms' : ReadingEntry[];
  }
  dailyGas: boolean;
  isApprox: boolean;

}


  export interface ServiceRelationship {
    service: {
      data: {
      id: string | number;
      type: 'primary' | 'secondary' | 'tertiary';
      }
    };
  }
export class ReadingEntry {
  value: number;
  timestamp: Date;

  constructor(value: number | any, timestamp: Date) {
    this.value = value;
    this.timestamp = timestamp;
  }
}

export interface ReadingsProps {
  id: string | number;
  dailyGas: number;
  isApproximate: boolean;
  relationship: ServiceRelationship[] | null;
  readings: ReadingEntry[];
}

export class Reading {
  id: string | number;
  dailyGas: boolean;
  isApproximate: boolean;
  relationship: ServiceRelationship[] | null;
  total_consumption?: number;
  readings: ReadingEntry[];
  unit?: 'kw' | 'mlb' | 'ccf' | 'therms';
  start_date?: string;
  end_date?: string;
  average_daily_consumption?: number;

  constructor(
    id: string | number,
    attributes: Attributes,
    relationship: ServiceRelationship[] | null,
  ) {
    this.id = id;
    this.dailyGas = attributes.dailyGas;
    this.isApproximate = attributes.isApprox;
    this.relationship = relationship;
    this.unit = attributes.readings.ccf.length > 0 ? 'ccf' : attributes.readings.mlb.length > 0 ? 'mlb' : attributes.readings.therms.length > 0 ? 'therms' : 'kw';
    this.readings = Object.entries(attributes.readings[this.unit]).map(([key, value]) => {
      return  new ReadingEntry(value, new Date(key));
    });
    this.total_consumption = 0;
    this.average_daily_consumption = 0;
  }

  // Method to get the total number of readings
  getReadingCount(): number {
    return this.readings.length;
  }
}

export default Reading;